// src/components/FeaturesPage.jsx
import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const FeaturesPage = () => {
  const features = [
    {
      title: 'Канбан-доска',
      description: 'Визуальное управление задачами с помощью перетаскивания',
      icon: 'bi-kanban',
      color: 'primary'
    },
    {
      title: 'Уведомления',
      description: 'Real-time уведомления о важных событиях',
      icon: 'bi-bell',
      color: 'success'
    },
    {
      title: 'Аналитика',
      description: 'Детальная статистика и отчеты',
      icon: 'bi-graph-up',
      color: 'info'
    },
    {
      title: 'API',
      description: 'Интеграция с другими системами',
      icon: 'bi-plug',
      color: 'warning'
    },
    {
      title: 'Безопасность',
      description: 'Двухфакторная аутентификация',
      icon: 'bi-shield-check',
      color: 'danger'
    },
    {
      title: 'Мобильность',
      description: 'Полностью адаптивный дизайн',
      icon: 'bi-phone',
      color: 'purple'
    },
  ];

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header */}
      <header className="bg-white border-bottom py-3">
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <Link to="/" className="text-decoration-none">
                <div className="logo-placeholder">
                  Tt
                </div>
              </Link>
              <div className="ms-3">
                <Link to="/" className="text-decoration-none">
                  <h5 className="mb-0 text-primary fw-bold">НЕЗАВИСИМАЯ ОЦЕНКИ КАЧЕСТВА</h5>
                </Link>
                <small className="text-muted">Возможности</small>
              </div>
            </div>
            <div>
              <Link to="/" className="btn btn-link text-decoration-none me-3">
                Главная
              </Link>
              <Link to="/about" className="btn btn-link text-decoration-none me-3">
                О нас
              </Link>
              <Link to="/login" className="btn btn-outline-primary me-2">
                Войти
              </Link>
              <Link to="/login" className="btn btn-primary">
                Регистрация
              </Link>
            </div>
          </div>
        </Container>
      </header>

      {/* Hero */}
      <section className="gradient-bg text-white py-5">
        <Container>
          <Row className="py-5">
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-5 fw-bold mb-4">
                Мощные возможности для вашей продуктивности
              </h1>
              <p className="lead opacity-75">
                Исследуйте все инструменты, которые помогут вашей команде работать эффективнее
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Grid */}
      <section className="py-5">
        <Container>
          <Row className="g-4">
            {features.map((feature, index) => (
              <Col md={6} lg={4} key={index}>
                <Card className="border-0 shadow-sm h-100 hover-lift">
                  <Card.Body className="p-4">
                    <div className={`feature-icon bg-${feature.color} bg-opacity-10 text-${feature.color} mb-3`}>
                      <i className={`bi ${feature.icon} fs-3`}></i>
                    </div>
                    <h4 className="mb-3">{feature.title}</h4>
                    <p className="text-muted mb-0">{feature.description}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Pricing CTA */}
      <section className="bg-light py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <Badge bg="primary" className="mb-3 px-3 py-2">Бесплатный тариф</Badge>
              <h2 className="mb-3">Начните бесплатно</h2>
              <p className="lead text-muted mb-4">
                Все основные функции доступны в бесплатном тарифе. 
                Перейдите на премиум для расширенных возможностей.
              </p>
              <Link to="/login" className="btn btn-primary btn-lg px-5">
                Начать бесплатно
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <footer className="bg-white border-top py-4 mt-auto">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="logo-placeholder me-3">
                  Tt
                </div>
                <div>
                  <h6 className="mb-0 text-primary fw-bold"></h6>
                  <small className="text-muted">Возможности без границ</small>
                </div>
              </div>
            </Col>
            <Col md={6} className="text-end">
              <p className="text-muted small mb-0">
                HAKSTER  | {new Date().getFullYear()} 
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default FeaturesPage;